import './App.css';
import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { About } from './pages/About';
import { Home } from './pages/Home';
import { SignUp } from './pages/SignUp';
import { LogIn } from './pages/LogIn';
import { PersonalArea } from './pages/PersonalArea';
import { Header } from './components/Header';
import { Footer } from './components/Footer';

function App() {
  return (
    <BrowserRouter>
        <Header />
        <Routes>
          <Route path={'/crowd-detection'} exact element={<Home />} />
          <Route path={'/crowd-detection/about'} element={<About />} />
          <Route path={'/crowd-detection/signup'} element={<SignUp />} />
          <Route path={'/crowd-detection/login'} element={<LogIn />} />
          <Route path={'/crowd-detection/personal-area/*'} element={<PersonalArea />} />
        </Routes>
        <Footer />
    </BrowserRouter>
  );
}

export default App;
